<div class="agpr-formField agpr-linkField">
    <div
        *ngIf="field.label"
        class="agpr-linkField-header"
        role="group"
        [attr.aria-label]="field.label | localize"
    >
        <span class="agpr-linkField-header-label">
            {{ field.label | localize }}
        </span>
        <agpr-button
            id="linkField.linkButton"
            class="agpr-linkField-header-linkButton"
            [style]="buttonTypes.tertiary"
            [label]="value ? 'PageBuilder.formField.button.editLinkText' : 'PageBuilder.formField.button.addLinkText'"
            (click)="openLinkDialog()"
            [ariaDescribedBy]="'linkField_value'"
        ></agpr-button>
    </div>
    <div
        *ngIf="!value || !value.url && !value.email"
        class="agpr-linkField-placeholder"
        id="linkField_value"
    >
        {{ field.placeholder | localize }}
    </div>
    <div
        *ngIf="value"
        class="agpr-linkField-value"
        id="linkField_value"
    >
        <span
            *ngIf="value.url"
        >
            {{ 'PageBuilder.formField.button.linkLabelURL' | localize }}
        </span>
        <span
            *ngIf="value.email"
        >
            {{ 'PageBuilder.formField.button.linkLabelEmail' | localize }}
        </span>
        <span> {{ displayLink }} </span>
    </div>
</div>
